module.exports = __webpack_public_path__ + "img/whfw.2ae72eb1.png";